// Typelizer digest 851aa13b196368d8c52dd384b6d29988
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /accountant/clients/:client_id/chart_approval */
  create: (
    params: { clientId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/accountant/clients/:client_id/chart_approval', params, options),
    method: 'post',
  }),
}
